import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import { useTranslation } from 'react-i18next';

dayjs.extend(isToday);
dayjs.extend(isYesterday);

export const useGetRelativeLabel = (date: Date) => {
  const timestamp = dayjs(date);
  const { t } = useTranslation('inbox');
  if (timestamp.isToday()) return t('Today');
  if (timestamp.isYesterday()) return t('Yesterday');

  return null;
};
